// src/pages/UserGuidePage.js
import React from 'react';

export default function UserGuidePage() {
  return (
    <div className="card" style={{ maxWidth: 720, margin: '12px auto', textAlign: 'left' }}>
      <h2 style={{ marginTop: 0 }}>Survey User Guide</h2>

      <p className="muted" style={{ marginTop: 0 }}>
        Welcome to the survey service provided by the getSurvey platform. Here’s a quick overview of what you can do.
      </p>

      <h3>Create Surveys</h3>
      <ul>
        <li>Create manually: add multiple-choice or free-text questions, reorder, and publish.</li>
        <li>Use AI: enter a short prompt and let AI draft questions for you.</li>
      </ul>

      <h3>Share & Respond</h3>
      <ul>
        <li>Share a direct link to your survey with others.</li>
        <li>Respond to surveys and see what others think.</li>
        <li>Like surveys you find useful.</li>
        <li>Discuss via comments and replies on the survey page.</li>
        <li>Report a survey to request removal if it’s inappropriate.</li>
      </ul>

      <h3 id="challenge-questions">Challenge Questions</h3>
      <p>
        Challenge questions are optional prompts that act as an authenticity check. Use them when you only want
        responses from people who understand the survey’s context—such as employees at your company, teammates on a
        project, or members of a specific organization. Ask for details that insiders will know (for example, the name
        of the latest release, a shared internal acronym, or a project milestone). Respondents must answer correctly
        before their submission is accepted.
      </p>
      <ul>
        <li>Great for employee satisfaction, internal retros, or any survey aimed at a defined group.</li>
        <li>Skip them for broad public feedback where every perspective is welcome.</li>
        <li>Keep the expected answer concise and unambiguous so you can verify authenticity quickly.</li>
      </ul>

      <h3>Analytics</h3>
      <ul>
        <li>Multiple‑choice breakdowns by option.</li>
        <li>Free‑text sentiment and top keywords (experimental).</li>
        <li>Response counts and recent activity.</li>
      </ul>

      <h3>Access & Visibility</h3>
      <ul>
        <li>Make surveys public or code‑protected.</li>
        <li>Optional geo scope for local audiences.</li>
      </ul>

      <div className="muted" style={{ marginTop: 8 }}>
        Tip: You can start from the Search page and browse popular or feedback surveys for inspiration.
      </div>
    </div>
  );
}
